import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-cobalt/10 px-5 py-6 sm:py-12" data-id="element-116" data-mp="223eltma3nb3z">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-cobalt/40 bg-white/70 p-6 text-center sm:p-12" data-id="element-117" data-mp="222wk4a4o44oo">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep sm:h-16 sm:w-16" data-id="element-118" data-mp="1j528rpg2hh34">
          <ShieldCheckIcon className="h-7 w-7 sm:h-9 sm:w-9" aria-hidden="true" data-id="element-119" data-mp="1ec97jbjt4qvs" />
        </span>
        <h2 className="mt-4 font-serif-display text-xl font-bold text-ink sm:mt-5 sm:text-3xl" data-id="element-120" data-mp="qmyd0bt1vsq3">
          Garantie de remboursement de 7 jours
        </h2>
        <div className="mt-4 space-y-4 text-[13px] leading-relaxed text-ink/75 sm:mt-6 sm:text-base" data-id="element-121" data-mp="ozro0as4edzt">
          <p data-id="element-122" data-mp="tycnu93gmvnq">
            Vous pouvez parcourir les ressources sereinement. Si CHIMIE VISUELLE™ ne correspond pas
            aux besoins de vos classes, il vous suffit de nous contacter dans les sept jours suivant
            l’achat pour demander un remboursement, selon les conditions indiquées dans notre
            politique de remboursement.
          </p>
        </div>
        <div className="mt-6 w-full max-w-md sm:mt-8" data-id="element-123" data-mp="630bck732x4q">
          <CTAButton label="JE VEUX PRÉPARER MES COURS PLUS RAPIDEMENT" data-id="element-124" data-mp="b0jmhb8hitsg" />
          <p className="mt-2.5 text-xs text-ink/60 sm:text-sm" data-id="element-125" data-mp="f0u45l5n38n5">
            Paiement unique · Aucun abonnement · Accès numérique · Accès à vie
          </p>
        </div>
      </motion.div>
    </section>;
}